import React, { useEffect, useState } from "react";
import { Table, Spin } from "antd";
import aiConsoleService from "services/aiconsoleservice";

const columns = [
  { title: "When", dataIndex: "when", key: "when", render: (v) => (v ? new Date(v).toLocaleString() : "") },
  { title: "Who", dataIndex: "who", key: "who" },
  { title: "Change", dataIndex: "what_changed", key: "what_changed", render: (v, r) => v || r.action },
  { title: "Reason", dataIndex: "reason", key: "reason", render: (v) => <span className="whitespace-pre-wrap">{v || ""}</span> },
];

const History = ({ agentKey }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let active = true;
    aiConsoleService.getAgentHistory(agentKey)
      .then((res) => active && setRows(res?.data ?? []))
      .catch(() => active && setRows([]));
    return () => { active = false; };
  }, [agentKey]);

  if (rows === null) return <div className="p-8 flex justify-center"><Spin /></div>;

  return (
    <div data-testid="history-panel" className="overflow-x-auto">
      <Table
        size="small"
        rowKey="id"
        dataSource={rows}
        columns={columns}
        pagination={{ pageSize: 15 }}
        locale={{ emptyText: "No changes recorded yet." }}
      />
    </div>
  );
};

export default History;
